import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { ReactComponent as Logo } from "../../Icons/LobyLogo.svg";
import {
  StyledSecondaryServiceTypography,
  SecondaryTypographyDefault,
} from "../../Theme";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/sales-overview");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: "40px 24px 40px 24px",
          borderRadius: "12px",
          boxShadow:
            "0px 2px 1px 0px rgba(0, 0, 0, 0.05), 0px 0px 1px 0px rgba(0, 0, 0, 0.25)",
          width: "30%",
        }}
      >
        <Box>
          <Logo style={{ marginBottom: "10px" }} />
          <StyledSecondaryServiceTypography>
            Operation Platform
          </StyledSecondaryServiceTypography>
        </Box>
        <Box sx={{ marginTop: "20px" }}>
          <SecondaryTypographyDefault>Email Address</SecondaryTypographyDefault>
          <TextField
            sx={{
              "& .MuiInputBase-root": {
                color: "#111927",
              },
              backgroundColor: "#F9FAFB",
            }}
            InputProps={{
              disableUnderline: true,
            }}
            fullWidth
          />
        </Box>
        <Box sx={{ marginTop: "20px" }}>
          <SecondaryTypographyDefault>Password</SecondaryTypographyDefault>
          <TextField
            sx={{
              "& .MuiInputBase-root": {
                color: "#111927",
              },
              backgroundColor: "#F9FAFB",
            }}
            InputProps={{
              disableUnderline: true,
            }}
            fullWidth
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "25px",
          }}
        >
          <Button
            sx={{
              borderRadius: "8px",
              padding: "10px 18px 10px 18px",
              backgroundColor: "#0E5E84",
              color: "#FFFFFF",
              fontSize: "16px",
              fontWeight: 600,
            }}
            fullWidth
            variant="contained"
            onClick={handleLogin}
          >
            Login
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
